<template>
	<el-card>
		<advanced-search-bar>
			<template>
				<form-item-sites :abbr="false" :multiple="false" :local="true" v-model="queryForm.channel" :parent="false"
					@onload="q.channel=queryForm.channel;getList()" :clearable="false"></form-item-sites>
				<form-item>
					<el-button type="primary" size="mini" icon="el-icon-search" @click="searchEvent">查 询</el-button>
				</form-item>
				<form-item>
					<el-button type="primary" size="mini" @click="visible.add=true">添加配置</el-button>
				</form-item>
			</template>
			<template #advanced>
				<form-item label="BM ID:" style="width:200px;">
					<el-input v-model="queryForm.bmId" placeholder="请输入" size="mini"></el-input>
				</form-item>
				<form-item v-if="false" label="Account ID:" style="width:250px;">
					<el-input v-model="queryForm.accountId" placeholder="请输入" size="mini"></el-input>
				</form-item>
				<form-item label="APP ID:" style="width:250px;">
					<el-input v-model="queryForm.appId" placeholder="请输入" size="mini"></el-input>
				</form-item>
			</template>
		</advanced-search-bar>
		<div style="background-color:#DCDFE6;height:1px;margin:0 0 24px -20px;width:calc(100% + 40px);"></div>
		<facebook-table class="mt-3 w-100" :tableData="tableData" @changePublish="changeActive" @editRow="editRow" @delRow="delRow">
		</facebook-table>
		<el-pagination class="mt-3" style="text-align:right;" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" :current-page.sync="page.current" :page-size="page.size"
			:page-sizes="page.sizes" layout="prev, pager, next, sizes, jumper" :total="page.total">
		</el-pagination>
		<el-dialog :visible.sync="visible.add" :before-close="handleClose">
			<el-form ref="form" :model="form" :rules="rules" :hide-required-asterisk="true" label-width="100px">
				<el-form-item-sites :abbr="false" v-model="form.channel" prop="channel" label-width="100px">
				</el-form-item-sites>
				<el-form-item label="BM ID:" prop="bmId">
					<el-input v-model.trim="form.bmId" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item v-if="false" label="Pixel ID:" prop="pixelId">
					<el-input v-model.trim="form.pixelId" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="APP ID:" prop="appId">
					<el-input v-model.trim="form.appId" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="APP Secret:" prop="secret">
					<el-input v-model.trim="form.secret" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="Token:" prop="token">
					<el-input v-model.trim="form.token" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item v-if="false" label="Account ID:" prop="accountId">
					<el-input v-model.trim="form.accountId" placeholder="请输入"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="visible.add = false">取 消</el-button>
				<el-button type="primary" @click="doCreateOrUpdate">确 定</el-button>
			</div>
		</el-dialog>
	</el-card>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import FacebookTable from '@/components/token/facebook-table.vue'
	import config from './minixs/index.js'
	const InitialForm = {
		channel: '',
		bmId: '',
		appId: '',
		secret: '',
		token: '',
		// accountId:'',
		// pixelId:''
	}
	export default {
		mixins: [config],
		components: {
			FacebookTable
		},
		data() {
			return {
				queryForm: {
					channel: '',
					bmId: '',
					accountId:'',
					appId: ''
				},
				tableData: [],
				q: {
					channel: ''
				},
				visible: {
					add: false
				},
				form: {
					...InitialForm
				},
				rules: {
					channel: [{
						required: true,
						message: '站点缩写不能为空'
					}],
					bmId: [{
						required: true,
						message: 'BM id不能为空'
					}],
					appId: [{
						required: true,
						message: 'APP ID不能为空'
					}],
					secret: [{
						required: true,
						message: 'APP Secret不能为空'
					}],
					token: [{
						required: true,
						message: 'Token不能为空'
					}],
					pixelId: [{
						required: true,
						message: 'Pixel ID不能为空'
					}],
					accountId: [{
						required: true,
						message: 'Account ID不能为空'
					}]
				},
				namespace: 'fb-token'
			}
		},
		methods: {
			editRow(item) {
				this.form = {
					...InitialForm,
					...item
				}
				this.visible.add = true
			}
		},
		watch: {
			'visible.add'(newVal, oldVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.$refs.form.clearValidate()
					})
				} else {
					this.form = {
						...InitialForm
					}
				}
			}
		}
	}
</script>

<style>
</style>
